import { FC } from "react";

import InfoCard from "components/InfoCard";
import TextInput from "components/TextInput";

import styles from "./style.module.scss";

type Field = {
  label: string;
  unit: string;
  hint: string;
  value?: number;
  name?: string;
  error?: string;
};

type Props = {
  infoDescription: string;
  pmDescription?: string;
  gasFields: Field[];
  pmFields: Field[];
  handleFieldChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const IAQTabTemplate: FC<Props> = ({ infoDescription, pmDescription, gasFields, pmFields, handleFieldChange }) => {
  const renderField = ({ label, unit, hint, value, name, error }: Field) => (
    <fieldset key={label} className={styles.fieldset}>
      <p className={styles.fieldsetTitle}>
        <span className={styles.fieldsetTitleText}>{label}</span>
        <span className={styles.fieldsetTooltip}>{unit}</span>
      </p>

      {name != null && value != null && (
        <TextInput value={value} name={name} onChange={handleFieldChange} error={error} />
      )}

      {!error && (
        <p className={styles.fieldsetHint}>
          <span>!</span>
          <span>{hint}</span>
        </p>
      )}
    </fieldset>
  );

  return (
    <div className={styles.card}>
      <InfoCard color="gray" variant="secondary" size="small" className={styles.infoCard}>
        <p className={styles.cardTitle}>Important information:</p>

        <span className={styles.cardDescription}>{infoDescription}</span>
      </InfoCard>

      <div className={styles.fields}>{gasFields.map(renderField)}</div>

      <div className={styles.fieldsContainer}>
        <p className={styles.fieldsTitle}>Particulate matter (PM2.5 & PM10)</p>

        {pmDescription && <span className={styles.fieldsDescription}>{pmDescription}</span>}

        <div className={styles.fields}>{pmFields.map(renderField)}</div>
      </div>
    </div>
  );
};

export default IAQTabTemplate;
